import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "global-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "sidebar-section"
}
const _hoisted_3 = {
  key: 1,
  class: "sidebar-divider"
}
const _hoisted_4 = { class: "sidebar-nav" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "sidebar-bottom" }
const _hoisted_12 = { class: "user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sidebar-brand bg-no-repeat bg-cover" }, null, -1)),
    (_ctx.$slots.extra)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "extra", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasExtraSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/",
        custom: ""
      }, {
        default: _withCtx(({ href, navigate }) => [
          _createElementVNode("a", {
            href: href,
            class: _normalizeClass(["sidebar-item", { active: _ctx.isExactHome }]),
            onClick: navigate
          }, [
            _createElementVNode("img", {
              class: "sidebar-icon",
              src: 
              _ctx.isExactHome
                ? require('../../assets/images/tabs/tab_1_active.png')
                : require('../../assets/images/tabs/tab_1.png')
            ,
              alt: "首页"
            }, null, 8, _hoisted_6),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sidebar-label" }, "首页", -1))
          ], 10, _hoisted_5)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/generate",
        custom: ""
      }, {
        default: _withCtx(({ isActive, href, navigate }) => [
          _createElementVNode("a", {
            href: href,
            class: _normalizeClass(["sidebar-item", { active: isActive }]),
            onClick: navigate
          }, [
            _createElementVNode("img", {
              class: "sidebar-icon",
              src: 
              isActive
                ? require('../../assets/images/tabs/tab_2_active.png')
                : require('../../assets/images/tabs/tab_2.png')
            ,
              alt: "生成"
            }, null, 8, _hoisted_8),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sidebar-label" }, "生成", -1))
          ], 10, _hoisted_7)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/records",
        custom: ""
      }, {
        default: _withCtx(({ isActive, href, navigate }) => [
          _createElementVNode("a", {
            href: href,
            class: _normalizeClass(["sidebar-item", { active: isActive }]),
            onClick: navigate
          }, [
            _createElementVNode("img", {
              class: "sidebar-icon",
              src: 
              isActive
                ? require('../../assets/images/tabs/tab_3_active.png')
                : require('../../assets/images/tabs/tab_3.png')
            ,
              alt: "工作流"
            }, null, 8, _hoisted_10),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sidebar-label" }, "历史记录", -1))
          ], 10, _hoisted_9)
        ]),
        _: 1
      }),
      (_ctx.isAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/workflows",
            class: "sidebar-item",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "sidebar-icon" }, "📜", -1),
              _createElementVNode("span", { class: "sidebar-label" }, "工作流", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/users",
            class: "sidebar-item",
            "active-class": "active"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("span", { class: "sidebar-icon" }, "👥", -1),
              _createElementVNode("span", { class: "sidebar-label" }, "用户管理", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.account), 1),
            _createElementVNode("button", {
              class: "logout-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
            }, "退出")
          ], 64))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "login-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('login')))
          }, "登录"))
    ])
  ]))
}